import { render, staticRenderFns } from "./OshaNewsList.vue?vue&type=template&id=9e2f01e8"
import script from "./OshaNewsList.vue?vue&type=script&lang=js"
export * from "./OshaNewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports